export default __webpack_public_path__ + "0f8abbad8a13b00469fd2147beb1d84f.svg";